import { z } from 'zod';

/**
 * Get environment variable with widget context support
 * Checks widget environment first, then falls back to Vite environment
 */
export function getEnv() {
  // Check if we're in widget context
  if (typeof window !== 'undefined' && window.__WIDGET_ENV__) {
    return window.__WIDGET_ENV__;
  }

  // Fallback to Vite environment
  return import.meta.env;
}

const envsSchema = z.object({
  VITE_API_URL: z.string().default(''),
  VITE_X_API_KEY: z.string().optional(),
  VITE_SUPABASE_URL: z.string().default(''),
  VITE_SUPABASE_ANON_KEY: z.string().default(''),
  VITE_SUPABASE_MESSAGE_ATTACHMENTS_BUCKET_PUBLIC: z.string().default(''),
  VITE_WHATSAPP_SERVER_URL: z.string().default(''),
  VITE_WHATSAPP_SERVER_API_KEY: z.string().default(''),
  VITE_WHATSAPP_SERVER_WEBSOCKET_URL: z.string().default(''),
});
const environment = getEnv();
const envsParsed = envsSchema.safeParse(environment);

let envs: z.infer<typeof envsSchema>;

if (!envsParsed.success) {
  console.warn(
    'Some environment variables are missing, using defaults:',
    envsParsed.error.flatten().fieldErrors,
  );
  // Use defaults instead of throwing - allows widget to load in development
  const defaults = {
    VITE_API_URL: '',
    VITE_SUPABASE_URL: '',
    VITE_SUPABASE_ANON_KEY: '',
    VITE_SUPABASE_MESSAGE_ATTACHMENTS_BUCKET_PUBLIC: '',
    VITE_WHATSAPP_SERVER_URL: '',
    VITE_WHATSAPP_SERVER_API_KEY: '',
    VITE_WHATSAPP_SERVER_WEBSOCKET_URL: '',
    ...environment,
  };
  envs = defaults as z.infer<typeof envsSchema>;
} else {
  envs = envsParsed.data;
}

export { envs };
